import { RingLoader } from "../../_components";
import React, { useMemo, useState } from "react";
import "./table.scss";

export const Table = ({
  data,
  headers,
  onSort,
  defaultSort,
  className,
  headerClassName,
  tableClassName,
  noDataTitle,
}) => {
  const [sort, setSort] = useState(
    defaultSort
      ? { ...defaultSort }
      : {
          key: "",
          sortType: null,
        }
  );

  const memoizedHeaders = useMemo(() => headers, [headers]);

  const sortHandler = (key) => {
    if (key === sort.key) {
      const sortType = sort.sortType === "DESC" ? "ASC" : "DESC";
      setSort({
        key,
        sortType,
      });
      onSort && onSort(key, sortType);
    } else {
      setSort({
        key: key,
        sortType: "DESC",
      });
      onSort && onSort(key, "DESC");
    }
  };

  const renderRows = () => {
    return data?.map((row, rowIndex) => (
      <tr className={`tbody_tr`} key={`tr-item-${rowIndex}`}>
        {row.map((cell, colIndex) => (
          <td className={`tbody_td`} key={`td-item-${colIndex}`}>
            {cell}
          </td>
        ))}
      </tr>
    ));
  };

  const sortViewHandler = (key) => {
    if (key === sort.key && sort.sortType !== null) {
      return sort.sortType === "DESC" ? (
        <i className="fa fa-arrow-alt-down text-light mr-1" />
      ) : (
        <i className="fa fa-arrow-alt-up text-light mr-1" />
      );
    }
    return <i className="fa fa-arrows-alt-v text-light mr-1" />;
  };

  return (
    <div className={`table_container ${className || ""}`}>
      <table className={`table_new ${tableClassName || ""}`}>
        <thead className={`${headerClassName || ""}`}>
          <tr className={`${headerClassName || ""}`}>
            {memoizedHeaders?.map((column, index) =>
              column.sortable && column.key ? (
                <th
                  key={`th-item-${index}`}
                  onClick={() => sortHandler(column.key)}
                  className="thead_th pointer"
                >
                  <div className="sort_container">
                    {column.child}
                    {column.sortable && (
                      <span className="column_filter">
                        {sortViewHandler(column.key)}
                      </span>
                    )}
                  </div>
                </th>
              ) : (
                <th key={`th-item-${index}`} className="thead_th">
                  <div className={`sort_container`}>{column.child}</div>
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>{data && data.length > 0 && renderRows()}</tbody>
      </table>
      {data === null && (
        <div className="loading_container">
          <RingLoader />
        </div>
      )}
      {data && data.length === 0 && (
        <div className="empty_container">
          <div>
            <p className="not_found_text">{noDataTitle || "موردی یافت نشد."}</p>
          </div>
        </div>
      )}
    </div>
  );
};
